var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('component',_vm._b({},'component',_vm.homeLinkAttributes,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }